import { render, staticRenderFns } from "./ApplyForReturn.vue?vue&type=template&id=72fad08a&scoped=true"
import script from "./ApplyForReturn.vue?vue&type=script&lang=js"
export * from "./ApplyForReturn.vue?vue&type=script&lang=js"
import style0 from "./ApplyForReturn.vue?vue&type=style&index=0&id=72fad08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fad08a",
  null
  
)

export default component.exports